export const VIEWER_TRANSLATION_LOADERS = {
    ar: ()=>import('../assets/locale/messages_ar.json'),
    bg: ()=>import('../assets/locale/messages_bg.json'),
    ca: ()=>import('../assets/locale/messages_ca.json'),
    cs: ()=>import('../assets/locale/messages_cs.json'),
    da: ()=>import('../assets/locale/messages_da.json'),
    de: ()=>import('../assets/locale/messages_de.json'),
    el: ()=>import('../assets/locale/messages_el.json'),
    en: ()=>import('../assets/locale/messages_en.json'),
    es: ()=>import('../assets/locale/messages_es.json'),
    fi: ()=>import('../assets/locale/messages_fi.json'),
    fr: ()=>import('../assets/locale/messages_fr.json'),
    he: ()=>import('../assets/locale/messages_he.json'),
    hi: ()=>import('../assets/locale/messages_hi.json'),
    hr: ()=>import('../assets/locale/messages_hr.json'),
    hu: ()=>import('../assets/locale/messages_hu.json'),
    id: ()=>import('../assets/locale/messages_id.json'),
    it: ()=>import('../assets/locale/messages_it.json'),
    ja: ()=>import('../assets/locale/messages_ja.json'),
    ko: ()=>import('../assets/locale/messages_ko.json'),
    lt: ()=>import('../assets/locale/messages_lt.json'),
    lv: ()=>import('../assets/locale/messages_lv.json'),
    ms: ()=>import('../assets/locale/messages_ms.json'),
    nl: ()=>import('../assets/locale/messages_nl.json'),
    no: ()=>import('../assets/locale/messages_no.json'),
    pl: ()=>import('../assets/locale/messages_pl.json'),
    pt: ()=>import('../assets/locale/messages_pt.json'),
    ro: ()=>import('../assets/locale/messages_ro.json'),
    ru: ()=>import('../assets/locale/messages_ru.json'),
    sk: ()=>import('../assets/locale/messages_sk.json'),
    sl: ()=>import('../assets/locale/messages_sl.json'),
    sv: ()=>import('../assets/locale/messages_sv.json'),
    th: ()=>import('../assets/locale/messages_th.json'),
    tl: ()=>import('../assets/locale/messages_tl.json'),
    tr: ()=>import('../assets/locale/messages_tr.json'),
    uk: ()=>import('../assets/locale/messages_uk.json'),
    vi: ()=>import('../assets/locale/messages_vi.json'),
    zh: ()=>import('../assets/locale/messages_zh.json')
};
export const FIELD_TRANSLATION_LOADERS = {
    ar: ()=>import('@wix/form-fields/dist/esm/assets/locale/viewer/messages_ar.json'),
    bg: ()=>import('@wix/form-fields/dist/esm/assets/locale/viewer/messages_bg.json'),
    ca: ()=>import('@wix/form-fields/dist/esm/assets/locale/viewer/messages_ca.json'),
    cs: ()=>import('@wix/form-fields/dist/esm/assets/locale/viewer/messages_cs.json'),
    da: ()=>import('@wix/form-fields/dist/esm/assets/locale/viewer/messages_da.json'),
    de: ()=>import('@wix/form-fields/dist/esm/assets/locale/viewer/messages_de.json'),
    el: ()=>import('@wix/form-fields/dist/esm/assets/locale/viewer/messages_el.json'),
    en: ()=>import('@wix/form-fields/dist/esm/assets/locale/viewer/messages_en.json'),
    es: ()=>import('@wix/form-fields/dist/esm/assets/locale/viewer/messages_es.json'),
    fi: ()=>import('@wix/form-fields/dist/esm/assets/locale/viewer/messages_fi.json'),
    fr: ()=>import('@wix/form-fields/dist/esm/assets/locale/viewer/messages_fr.json'),
    he: ()=>import('@wix/form-fields/dist/esm/assets/locale/viewer/messages_he.json'),
    hi: ()=>import('@wix/form-fields/dist/esm/assets/locale/viewer/messages_hi.json'),
    hr: ()=>import('@wix/form-fields/dist/esm/assets/locale/viewer/messages_hr.json'),
    hu: ()=>import('@wix/form-fields/dist/esm/assets/locale/viewer/messages_hu.json'),
    id: ()=>import('@wix/form-fields/dist/esm/assets/locale/viewer/messages_id.json'),
    it: ()=>import('@wix/form-fields/dist/esm/assets/locale/viewer/messages_it.json'),
    ja: ()=>import('@wix/form-fields/dist/esm/assets/locale/viewer/messages_ja.json'),
    ko: ()=>import('@wix/form-fields/dist/esm/assets/locale/viewer/messages_ko.json'),
    lt: ()=>import('@wix/form-fields/dist/esm/assets/locale/viewer/messages_lt.json'),
    lv: ()=>import('@wix/form-fields/dist/esm/assets/locale/viewer/messages_lv.json'),
    ms: ()=>import('@wix/form-fields/dist/esm/assets/locale/viewer/messages_ms.json'),
    nl: ()=>import('@wix/form-fields/dist/esm/assets/locale/viewer/messages_nl.json'),
    no: ()=>import('@wix/form-fields/dist/esm/assets/locale/viewer/messages_no.json'),
    pl: ()=>import('@wix/form-fields/dist/esm/assets/locale/viewer/messages_pl.json'),
    pt: ()=>import('@wix/form-fields/dist/esm/assets/locale/viewer/messages_pt.json'),
    ro: ()=>import('@wix/form-fields/dist/esm/assets/locale/viewer/messages_ro.json'),
    ru: ()=>import('@wix/form-fields/dist/esm/assets/locale/viewer/messages_ru.json'),
    sk: ()=>import('@wix/form-fields/dist/esm/assets/locale/viewer/messages_sk.json'),
    sl: ()=>import('@wix/form-fields/dist/esm/assets/locale/viewer/messages_sl.json'),
    sv: ()=>import('@wix/form-fields/dist/esm/assets/locale/viewer/messages_sv.json'),
    th: ()=>import('@wix/form-fields/dist/esm/assets/locale/viewer/messages_th.json'),
    tl: ()=>import('@wix/form-fields/dist/esm/assets/locale/viewer/messages_tl.json'),
    tr: ()=>import('@wix/form-fields/dist/esm/assets/locale/viewer/messages_tr.json'),
    uk: ()=>import('@wix/form-fields/dist/esm/assets/locale/viewer/messages_uk.json'),
    vi: ()=>import('@wix/form-fields/dist/esm/assets/locale/viewer/messages_vi.json'),
    zh: ()=>import('@wix/form-fields/dist/esm/assets/locale/viewer/messages_zh.json')
};
export const LOCALE_DATASET_TRANSLATION_LOADERS = {
    ar: ()=>import('@wix/locale-dataset-data/resources/translations/messages_ar.json'),
    bg: ()=>import('@wix/locale-dataset-data/resources/translations/messages_bg.json'),
    ca: ()=>import('@wix/locale-dataset-data/resources/translations/messages_ca.json'),
    cs: ()=>import('@wix/locale-dataset-data/resources/translations/messages_cs.json'),
    da: ()=>import('@wix/locale-dataset-data/resources/translations/messages_da.json'),
    de: ()=>import('@wix/locale-dataset-data/resources/translations/messages_de.json'),
    el: ()=>import('@wix/locale-dataset-data/resources/translations/messages_el.json'),
    en: ()=>import('@wix/locale-dataset-data/resources/translations/messages_en.json'),
    es: ()=>import('@wix/locale-dataset-data/resources/translations/messages_es.json'),
    fi: ()=>import('@wix/locale-dataset-data/resources/translations/messages_fi.json'),
    fr: ()=>import('@wix/locale-dataset-data/resources/translations/messages_fr.json'),
    he: ()=>import('@wix/locale-dataset-data/resources/translations/messages_he.json'),
    hi: ()=>import('@wix/locale-dataset-data/resources/translations/messages_hi.json'),
    hr: ()=>import('@wix/locale-dataset-data/resources/translations/messages_hr.json'),
    hu: ()=>import('@wix/locale-dataset-data/resources/translations/messages_hu.json'),
    id: ()=>import('@wix/locale-dataset-data/resources/translations/messages_id.json'),
    it: ()=>import('@wix/locale-dataset-data/resources/translations/messages_it.json'),
    ja: ()=>import('@wix/locale-dataset-data/resources/translations/messages_ja.json'),
    ko: ()=>import('@wix/locale-dataset-data/resources/translations/messages_ko.json'),
    lt: ()=>import('@wix/locale-dataset-data/resources/translations/messages_lt.json'),
    lv: ()=>import('@wix/locale-dataset-data/resources/translations/messages_lv.json'),
    ms: ()=>import('@wix/locale-dataset-data/resources/translations/messages_ms.json'),
    nl: ()=>import('@wix/locale-dataset-data/resources/translations/messages_nl.json'),
    no: ()=>import('@wix/locale-dataset-data/resources/translations/messages_no.json'),
    pl: ()=>import('@wix/locale-dataset-data/resources/translations/messages_pl.json'),
    pt: ()=>import('@wix/locale-dataset-data/resources/translations/messages_pt.json'),
    ro: ()=>import('@wix/locale-dataset-data/resources/translations/messages_ro.json'),
    ru: ()=>import('@wix/locale-dataset-data/resources/translations/messages_ru.json'),
    sk: ()=>import('@wix/locale-dataset-data/resources/translations/messages_sk.json'),
    sl: ()=>import('@wix/locale-dataset-data/resources/translations/messages_sl.json'),
    sv: ()=>import('@wix/locale-dataset-data/resources/translations/messages_sv.json'),
    th: ()=>import('@wix/locale-dataset-data/resources/translations/messages_th.json'),
    tl: ()=>import('@wix/locale-dataset-data/resources/translations/messages_tl.json'),
    tr: ()=>import('@wix/locale-dataset-data/resources/translations/messages_tr.json'),
    uk: ()=>import('@wix/locale-dataset-data/resources/translations/messages_uk.json'),
    vi: ()=>import('@wix/locale-dataset-data/resources/translations/messages_vi.json'),
    zh: ()=>import('@wix/locale-dataset-data/resources/translations/messages_zh.json')
};

//# sourceMappingURL=translation-loaders.js.map